import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconBuilding: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 16.875H16.875V5C16.875 2.985 15.765 1.875 13.75 1.875H6.25C4.235 1.875 3.125 2.985 3.125 5V16.875H2.5C2.155 16.875 1.875 17.155 1.875 17.5C1.875 17.845 2.155 18.125 2.5 18.125H17.5C17.845 18.125 18.125 17.845 18.125 17.5C18.125 17.155 17.845 16.875 17.5 16.875ZM11.25 16.875H8.75V14.5833C8.75 14.0925 8.88417 13.9583 9.375 13.9583H10.625C11.1158 13.9583 11.25 14.0925 11.25 14.5833V16.875ZM12.5 16.875V14.5833C12.5 13.4092 11.7992 12.7083 10.625 12.7083H9.375C8.20083 12.7083 7.5 13.4092 7.5 14.5833V16.875H4.375V5C4.375 3.68583 4.93583 3.125 6.25 3.125H13.75C15.0642 3.125 15.625 3.68583 15.625 5V16.875H12.5ZM13.125 10.8333C13.125 11.1783 12.845 11.4583 12.5 11.4583H11.6667C11.3217 11.4583 11.0417 11.1783 11.0417 10.8333C11.0417 10.4883 11.3217 10.2083 11.6667 10.2083H12.5C12.845 10.2083 13.125 10.4883 13.125 10.8333ZM8.95833 10.8333C8.95833 11.1783 8.67833 11.4583 8.33333 11.4583H7.5C7.155 11.4583 6.875 11.1783 6.875 10.8333C6.875 10.4883 7.155 10.2083 7.5 10.2083H8.33333C8.67833 10.2083 8.95833 10.4883 8.95833 10.8333ZM13.125 8.33333C13.125 8.67833 12.845 8.95833 12.5 8.95833H11.6667C11.3217 8.95833 11.0417 8.67833 11.0417 8.33333C11.0417 7.98833 11.3217 7.70833 11.6667 7.70833H12.5C12.845 7.70833 13.125 7.98833 13.125 8.33333ZM8.95833 8.33333C8.95833 8.67833 8.67833 8.95833 8.33333 8.95833H7.5C7.155 8.95833 6.875 8.67833 6.875 8.33333C6.875 7.98833 7.155 7.70833 7.5 7.70833H8.33333C8.67833 7.70833 8.95833 7.98833 8.95833 8.33333ZM13.125 5.83333C13.125 6.17833 12.845 6.45833 12.5 6.45833H11.6667C11.3217 6.45833 11.0417 6.17833 11.0417 5.83333C11.0417 5.48833 11.3217 5.20833 11.6667 5.20833H12.5C12.845 5.20833 13.125 5.48833 13.125 5.83333ZM8.95833 5.83333C8.95833 6.17833 8.67833 6.45833 8.33333 6.45833H7.5C7.155 6.45833 6.875 6.17833 6.875 5.83333C6.875 5.48833 7.155 5.20833 7.5 5.20833H8.33333C8.67833 5.20833 8.95833 5.48833 8.95833 5.83333Z"
      fill={color}
    />
  </svg>
);

export default IconBuilding;
